import React, { useCallback, useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { sfx } from './rpSounds';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const PAGE = 30;
const fmt = (n) => Number(n || 0).toLocaleString('pt-BR');
const dataBr = (iso) => (iso ? new Date(iso).toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo', day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : '');
const ago = (iso) => {
  const s = Math.max(0, (Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 60) return 'agora';
  if (s < 3600) return `${Math.floor(s / 60)} min atrás`;
  if (s < 86400) return `${Math.floor(s / 3600)} h atrás`;
  return dataBr(iso);
};
const STATUS = { WON: ['Aguardando você receber na live', 'text-amber-300'], FAILED: ['Falhou — receba de novo', 'text-rose-300'], QUEUED: ['Entregando na sua live…', 'text-sky-300'], SENDING: ['Enviando…', 'text-sky-300'], DELIVERED: ['Entregue na live ✓', 'text-lime-300'], MANUAL_REVIEW: ['Em análise pela equipe', 'text-orange-300'], CANCELLED: ['Cancelado', 'text-zinc-400'], EXPIRED: ['Perdido — não recebido até o fim do evento', 'text-zinc-400'] };
const dedupe = (list) => { const seen = new Set(); return list.filter((w) => !seen.has(w.prize_id) && seen.add(w.prize_id)); };

// Aba "Ganhadores ao vivo" (padrão Roleta): filtro Todos | Meus. Todos = feed público com scroll infinito
// e atualização em tempo real (servidor); Meus = meus prêmios com status de entrega.
export const RpWinnersFeed = ({ me, tick = 0 }) => {
  const [filter, setFilter] = useState('all'); // all | mine
  const [list, setList] = useState([]);
  const [hasMore, setHasMore] = useState(false);
  const loading = useRef(false);

  const loadMore = useCallback(async (offset) => {
    if (loading.current) return;
    loading.current = true;
    try {
      const { data } = await axios.get(`${API}/rp/winners`, { params: { limit: PAGE, offset } });
      setList((prev) => dedupe(offset === 0 ? [...(data.winners || []), ...prev] : [...prev, ...(data.winners || [])]));
      if (offset > 0 || !list.length) setHasMore(!!data.has_more);
    } catch { /* noop */ }
    loading.current = false;
  }, [list.length]);

  useEffect(() => { loadMore(0); }, [tick]);
  useEffect(() => {                      // tempo real: puxa o topo do feed a cada 8s
    const id = setInterval(() => loadMore(0), 8000);
    return () => clearInterval(id);
  }, [loadMore]);

  const onScroll = (e) => {
    const el = e.currentTarget;
    if (hasMore && el.scrollTop + el.clientHeight >= el.scrollHeight - 60) loadMore(list.length);
  };
  const pick = (f) => { if (f !== filter) sfx.tab(); setFilter(f); };
  const Btn = ({ k, children, testid }) => (
    <button onClick={() => pick(k)} data-testid={testid} aria-selected={filter === k}
      className={`flex-1 rounded-lg border px-2 py-1.5 text-xs font-bold transition-colors ${filter === k
        ? 'border-lime-400 bg-lime-500/25 text-white' : 'border-white/10 bg-white/5 text-purple-300/80 hover:border-lime-400/50'}`}>
      {children}
    </button>
  );

  return (
    <div data-testid="rp-feed">
      <div className="mb-2 flex gap-1.5" data-testid="rp-feed-filters">
        <Btn k="all" testid="rp-feed-filter-all">🎉 Todos os ganhadores</Btn>
        <Btn k="mine" testid="rp-feed-filter-mine">🎁 Meus prêmios{me ? ` (${me.chests_opened})` : ''}</Btn>
      </div>

      {filter === 'all' && (
        list.length === 0
          ? <p className="py-4 text-center text-[11px] text-purple-200/70" data-testid="rp-feed-empty">Ninguém abriu um baú ainda — abra e apareça aqui! 🍀</p>
          : (
            <div className="custom-scrollbar max-h-72 space-y-1.5 overflow-y-auto pr-1" data-testid="rp-feed-scroll" onScroll={onScroll}>
              {list.map((w) => (
                <div key={w.prize_id} data-testid="rp-feed-item"
                  className={`flex items-center justify-between gap-2 rounded-lg border px-3 py-1.5 animate-in fade-in slide-in-from-top-2 duration-500 ${w.coins >= 5000 ? 'border-amber-400/40 bg-amber-500/10' : 'border-white/10 bg-white/5'}`}>
                  <div className="flex min-w-0 items-center gap-2">
                    {w.avatar ? <img src={w.avatar} alt="" className="h-8 w-8 shrink-0 rounded-full border border-fuchsia-400/60 object-cover" />
                      : <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-purple-900 text-xs font-black">{(w.nickname || '?')[0]}</span>}
                    <div className="min-w-0">
                      <p className="truncate text-sm font-bold text-white">{w.nickname} <span className="text-xs font-normal text-fuchsia-300/80">({w.kako_masked})</span></p>
                      <p className="text-[10px] text-purple-300/80">{ago(w.won_at)}</p>
                    </div>
                  </div>
                  <div className="flex shrink-0 items-center gap-1.5">
                    {w.coins >= 5000 && <span className="rounded border border-amber-400/50 bg-amber-500/20 px-1.5 py-0.5 text-[10px] font-black text-amber-300">RARO!</span>}
                    <img src={`/rp/${w.prop_id}.png`} alt="" className="h-7 w-7 object-contain" />
                    <span className="text-sm font-black text-amber-300">🪙{fmt(w.coins)}</span>
                  </div>
                </div>
              ))}
              {hasMore && <p className="py-1 text-center text-[10px] text-purple-300/70" data-testid="rp-feed-loading-more">role para carregar mais...</p>}
            </div>
          )
      )}

      {filter === 'mine' && (
        <div data-testid="rp-history">
          {me?.chests_expired > 0 && <p className="mb-2 text-right text-[10px] text-zinc-400" data-testid="rp-chests-expired">{me.chests_expired} baú(s) perdido(s) no encerramento</p>}
          <ul className="custom-scrollbar max-h-72 space-y-1.5 overflow-y-auto pr-1" data-testid="rp-history-list">
            {!me && <li className="py-4 text-center text-[11px] text-purple-200/70" data-testid="rp-history-login">Entre na sua conta para ver seus prêmios.</li>}
            {me && me.prizes.length === 0 && <li className="py-4 text-center text-[11px] text-purple-200/70">Nenhum baú aberto ainda — abra e apareça aqui! 🎁</li>}
            {(me?.prizes || []).map((p) => (
              <li key={p.prize_id} data-testid="rp-history-item" data-status={p.status}
                className={`flex items-center justify-between rounded-lg border px-3 py-1.5 ${p.status === 'EXPIRED' ? 'border-zinc-600/40 bg-zinc-800/40 grayscale' : 'border-white/10 bg-white/5'}`}>
                <span className="flex min-w-0 items-center gap-2 text-sm">
                  <img src={`/rp/${p.prop_id}.png`} alt="" className="h-9 w-9 shrink-0 object-contain" />
                  <span className="min-w-0"><b className="block truncate">{p.gift_name} · 🪙{fmt(p.coins)}</b><span className="text-[10px] text-purple-300/70">{dataBr(p.won_at)}</span></span>
                </span>
                <span className={`shrink-0 text-right text-[10px] font-bold ${STATUS[p.status]?.[1] || ''}`}>{STATUS[p.status]?.[0] || p.status}{p.error_public && p.status !== 'EXPIRED' ? <><br /><span className="font-normal text-rose-200/80">{p.error_public}</span></> : null}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default RpWinnersFeed;
